// eslint-disable-next-line canonical/filename-match-exported,@typescript-eslint/comma-dangle
enum AppEnvironment {
  demo = 'demo',
  development = 'development',
  production = 'production',
  staging = 'staging',
  test = 'test',
}

const env: AppEnvironment = (import.meta.env.VITE_APP_ENVIRONMENT ||
  'test') as AppEnvironment;

const NON_LOCAL_RECAPTCHA_SITE_KEYS = {
  v2: '6LcvKZ0qAAAAAO5FhDhNwI3VMXisNwQcC-RqKYSq',
  v3: '6Lc__ZwqAAAAAJTPLHCC5TdS-yi-Mjhvs6uv5Tu9',
};

const LOCAL_RECAPTCHA_SITE_KEYS = {
  v2: '6Lc_284qAAAAACQxZp0xcVDVgvVlbiYd6CjCzKZA',
  v3: '6Le1284qAAAAAEsnSyMjDLmZHyPb9ewjQ2HNCBs7',
};

const GEETEST_LOWER_ENVIRONMENT = {
  action: '11ab762b65dc7f4bfdfbbb7202874ec6',
};

const GEETEST_PRODUCTION_ENVIRONMENT = {
  action: 'd91c7c79903b3c6938b9f9cb3f7ed51e',
};

const environments = {
  demo: {
    apiUrl:
      import.meta.env.VITE_APP_API_URL || 'https://api.portal.demo.orcainc.com',
    env,
    fmsLoginUrl: import.meta.env.VITE_APP_FMS_URL || 'https://demo.orcainc.com',
    geetest: {
      action: GEETEST_LOWER_ENVIRONMENT.action,
    },
    recaptchaV2SiteKey: NON_LOCAL_RECAPTCHA_SITE_KEYS.v2,
    recaptchaV3SiteKey: NON_LOCAL_RECAPTCHA_SITE_KEYS.v3,
    resendVerificationTimeout:
      import.meta.env.VITE_APP_VERIFICATION_TIMEOUT || 30,
  },
  development: {
    apiUrl: import.meta.env.VITE_APP_API_URL || 'http://localhost:5000',
    env,
    fmsLoginUrl:
      import.meta.env.VITE_APP_FMS_URL || 'https://staging.orcainc.com',
    geetest: {
      action: GEETEST_LOWER_ENVIRONMENT.action,
    },
    recaptchaV2SiteKey: LOCAL_RECAPTCHA_SITE_KEYS.v2,
    recaptchaV3SiteKey: LOCAL_RECAPTCHA_SITE_KEYS.v3,
    resendVerificationTimeout:
      import.meta.env.VITE_APP_VERIFICATION_TIMEOUT || 15,
  },
  production: {
    apiUrl:
      import.meta.env.VITE_APP_API_URL || 'https://api.portal.orcainc.com',
    env,
    fmsLoginUrl: import.meta.env.VITE_APP_FMS_URL || 'https://fms.orcainc.com',
    geetest: {
      action: GEETEST_PRODUCTION_ENVIRONMENT.action,
    },
    recaptchaV2SiteKey: NON_LOCAL_RECAPTCHA_SITE_KEYS.v2,
    recaptchaV3SiteKey: NON_LOCAL_RECAPTCHA_SITE_KEYS.v3,
    resendVerificationTimeout:
      import.meta.env.VITE_APP_VERIFICATION_TIMEOUT || 15,
  },
  staging: {
    apiUrl:
      import.meta.env.VITE_APP_API_URL ||
      'https://api.portal.staging.orcainc.com',
    env,
    fmsLoginUrl:
      import.meta.env.VITE_APP_FMS_URL || 'https://staging.orcainc.com',
    geetest: {
      action: GEETEST_LOWER_ENVIRONMENT.action,
    },
    recaptchaV2SiteKey: NON_LOCAL_RECAPTCHA_SITE_KEYS.v2,
    recaptchaV3SiteKey: NON_LOCAL_RECAPTCHA_SITE_KEYS.v3,
    resendVerificationTimeout:
      import.meta.env.VITE_APP_VERIFICATION_TIMEOUT || 15,
  },
  test: {
    apiUrl: import.meta.env.VITE_APP_API_URL,
    env,
    fmsLoginUrl: import.meta.env.VITE_APP_FMS_URL,
    geetest: {
      action: GEETEST_LOWER_ENVIRONMENT.action,
    },
    recaptchaV2SiteKey: LOCAL_RECAPTCHA_SITE_KEYS.v2,
    recaptchaV3SiteKey: LOCAL_RECAPTCHA_SITE_KEYS.v3,
    resendVerificationTimeout:
      import.meta.env.VITE_APP_VERIFICATION_TIMEOUT || 15,
  },
};

export default environments[env];
